// tslint:disable:no-string-literal

export function activateOptimize() {
  if (window['dataLayer']) {
    window['dataLayer'].push({event: 'optimize.activate'});
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/google-optimize.ts